import ArrayUtils from '../../../../common/utils/array';
import UrlUtils from '../../../../common/utils/url';
import gameConfig from '../../config/game';


export default class Manager{

    constructor(){
        GAME_REF.obj.manager = this;

        this.startscr = null;
        this.dragon = null;
    }

    
    init(){
        this.query = UrlUtils.getQuery();

        this.dragon = GAME_REF.obj.dragon;
        this.startscr = GAME_REF.obj.startscr;
        this.ques = GAME_REF.obj.question;
        this.rec = GAME_REF.obj.recording;

        this.start();
    }


    start(){
        this.dragon.render();
        this.startscr.render();
    }


    kaisetsu(){
        this.startscr.hide();
        this.dragon.change();
        this.ques.render();
    }


    recording(){
        this.rec.start();
    }
}